import { connect } from 'react-redux';

import DashboardPage from './DashboardPage';
import { selectors } from '../../../dux/user';

const mapStateToProps = (state) => ({
  user: selectors.getIdentityState(state),
  accessToken: selectors.getCredentialsState(state).accessToken,
});

export default connect(mapStateToProps, {})(DashboardPage);
